import React, { useState, useEffect } from "react" ;

import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
// import { getMyPosts } from "root/DataFunctions/ChildDataFns";
import {updatePost, getUserPosts} from "root/DataFunctions/PostDataFns";
import {MessageType, PostStatus} from "root/DataFunctions/Constants";

import ChildPost from "../Components/ChildPost";
import Loading from "../Components/Loading";
import ChildPostDetailNew from "../Components/ChildPostDetailNew";

import '../styles/Layout/postsDashboard.scss';

const Published = () => {
    const [allPosts, setAllPosts] = useState(null);
    
    const [index, setIndex] = useState(null);
    const filteredPost = allPosts ? allPosts[index] : '';

    // Loop posts array
    const checkNumber = (number) => {
        if(number > allPosts.length - 1) {
            return 0;
        }
        if (number < 0) {
            return allPosts.length - 1;
        }
        return number;
    }
    
    const onNextPost = () => {
        setIndex((index) => {
            let newIndex = index + 1;
            return checkNumber(newIndex);
        })
    }
    
    const onPrevPost = () => {
        setIndex((index) => {
            let newIndex = index - 1;
            return checkNumber(newIndex);
        })
    }

    const onSetIndexFromPost = (indx) => {
        setIndex(indx)
    }

    // For Published and Draft
    const handleMoveToDrafts = (post_id) => {
        const formData = {operation: 'update_status', status: PostStatus.NOT_SENT};

        // const oldPosts = { ...allPosts };
        setAllPosts((prevPosts) => {
            const filtered = prevPosts.filter((item) => item.post_id !== post_id);
            return filtered;
        });

        updatePost('current', post_id, formData, MessageType.MESSAGE_TYPE_LIFESTORY, response =>
        {
            //setAllPosts(getDataFromResponse(response));
        });
    }

    useEffect(()=>{
        getData();
    }, []);

    const getData = () => {
        getUserPosts("sent", response =>
        {
            setAllPosts(getDataFromResponse(response));
        });
    };

    return (
        <>
            <div style={{display: "flex", flexDirection: "column", flex: "1"}}>
                <div className="child_breadcrumb child_breadcrumb-main">
                    <div className="child_breadcrumb_inner">
                        <h2 className="child_breadcrumb_title">My Sent Posts</h2>
                    </div>
                </div>
                <div className="child-post-items">
                    {allPosts 
                        && index !== null 
                        && <ChildPostDetailNew totalPost={allPosts.length} index={index} filteredPost={filteredPost} nextPost={onNextPost} prevPost={onPrevPost} setIndex={setIndex} postStatus={'published'}/>
                    }
                    {allPosts 
                        ? allPosts.map( (post, i) => 
                                        <ChildPost 
                                            key={post.post_id}
                                            post={post} 
                                            setIndexFromPost={onSetIndexFromPost} 
                                            postIndex={i}
                                            pubDraft={"published"}
                                            moveToDrafts={handleMoveToDrafts}
                                        /> 
                                    )
                        : <Loading />
                    }
                </div>
            </div>
        </>
    );
}

export default Published;
